module.exports = __webpack_public_path__ + "assets/4302d02af7c417f4e5acdee4e66ee10c.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/Multiple_Stem_XX.mp3
 ** module id = 499
 ** module chunks = 0
 **/